<template>
    <div style="height: 100%;background: white">
        <div style="background: white;">
            <div class="bg-head">
                <img style="width: 100%" src="../assets/img/card_bg.gif"/>
                <img @click="jumpTo('/userCenter')" style="position: absolute;right: 10px;top:10px;"
                     class="svg-icon"
                     src="../assets/img/home.svg"/>
            </div>
            <mt-loadmore :auto-fill="false" :bottomDropText="options.bottomDropText"
                         :bottomPullText="options.bottomPullText"
                         :top-method="loadTop" :bottom-method="loadBottom"
                         :bottom-all-loaded="!options.hasMore"
                         ref="loadmore">
                <div v-if="list.length > 0" class="list-view">
                    <div class="space-between ticket-card" v-for="item in list">
                        <div class="ticket-bg text-center vertical-center">
                            <div style="width: 1px;height: 100%"></div>
                            <div>
                                <div class="vertical-center text-center" style="color: white">
                                    <span v-if="item.type===1"
                                          style="font-size: 28px;vertical-align: bottom;">{{item.fillSubMoney}}</span>
                                    <span v-else-if="item.type===2"
                                          style="font-size: 28px;vertical-align: bottom;">{{item.cashMoney}}</span>
                                    <span style="vertical-align: bottom;padding-bottom: 6px;margin-left: 2px">元</span>
                                </div>
                                <div v-if="item.type===1"
                                     style="color: white;margin-top: 6px;font-size: 12px;padding-bottom: 10px">
                                    满{{item.fillMoney}}可使用
                                </div>
                                <div style="color: white;margin-top: 6px;font-size: 12px;padding-bottom: 10px"
                                     v-else-if="item.type===2">抵扣券
                                </div>
                            </div>
                        </div>
                        <div class="flex-1" style="margin-left: 16px">
                            <div style="font-size: 18px;font-weight: bold">{{item.name}}</div>
                            <div style="margin-top: 20px" class="hint-text">
                                {{item.startDate.substr(0, 10)}}至{{item.endDate.substr(0, 10)}}
                            </div>
                        </div>
                        <div>
                            <div @click="getTicket(item)" class="button" style="margin-right: 14px">领取</div>
                            <div @click="showMask = true" class="button-2"
                                 style="margin-right: 14px;margin-top:8px;">
                                分享
                            </div>
                        </div>

                        <!--<div class="button cannot" style="margin-right: 14px">已领取</div>-->
                    </div>
                </div>
                <div class="no-data" v-else>暂无优惠券</div>
            </mt-loadmore>
        </div>

        <div class="share-mask" @click="showMask = false" v-if="showMask">
            <img style="position: absolute;right: 0;top: 0;display: block" src="../assets/img/share_guide.png"/>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator, MessageBox, Toast} from 'mint-ui';

    export default {
        name: "tiketGet",
        data() {
            return {
                utils: utils,
                list: [],
                hasBind: false,
                bindNo: "",
                showMask: false,
                options: {
                    currentPage: 1,
                    pageSize: 10,
                    hasMore: false,
                    bottomDropText: "释放加载",
                    bottomPullText: "",
                },
            }
        },
        methods: {
            loadTop: function () {
                this.options.currentPage = 1;
                this.loadList((res) => {
                    this.$refs.loadmore.onTopLoaded();
                });
            },
            loadBottom: function () {
                this.options.loading = true;
                this.options.currentPage++;
                this.loadList((res) => {
                    this.$refs.loadmore.onBottomLoaded();
                });
            },
            viewDetail: function (item) {

            },
            loadList: function (onload) {
                Indicator.open('加载中...');
                window.Indicator = Indicator;
                api.getFormUrl(this, "yy/front/discount/getProductList", {
                    pageNo: this.options.currentPage,
                    pageSize: 15,
                    effectFlag: true,
                    gainPerson: this.bindNo
                }, (res) => {
                    if (this.options.currentPage == 1) {
                        this.list = [];
                    }
                    this.list = this.list.concat(res.data)
                    if (res.total <= res.pageNo * res.pageSize) {
                        this.options.hasMore = false;
                        this.options.bottomPullText = "没有更多了";
                    } else {
                        this.options.hasMore = true;
                        this.options.bottomPullText = "加载更多";
                    }
                    onload(res);
                    Indicator.close();
                }, () => {
                    Indicator.close();
                })
            },
            isRegist: function (callback) {
                console.log(3);
                if (this.hasBind) {
                    callback && callback();
                } else {
                    MessageBox({
                        title: '提示',
                        closeOnClickModal:false,
                        message: '尚未绑定患者，请前往绑定?',
                        confirmButtonText: "前往绑定"
                    }).then(() => {
                        this.$router.push({
                            path: "/bindPatient",
                            query: {
                                YY_USER_ID: this.$route.query.YY_USER_ID,
                                openId: this.$route.query.openId
                            }
                        })
                    }).catch(() => {

                        // this.chargeInfo = "请先绑定患者用户"
                    });
                }
            },
            getTicket: function (item) {
                var _this = this;
                _this.isRegist(() => {
                    api.postFormUrl(_this, "yy/front/discount/gain", {
                        discountProductId: item.id,
                        gainPerson: _this.bindNo,
                    }, (res) => {
                        Toast({
                            message: "领取成功",
                            position: 'bottom',
                            duration: 5000
                        });
                        Indicator.close();
                        _this.loadList(1)
                    }, (msg) => {
                        Toast({
                            message: msg.rspDesc,
                            position: 'bottom',
                            duration: 5000
                        });
                        Indicator.close();
                    })
                });

            },
            shareTicket: function () {
                var _this = this;
                // alert(1)
                // this.isRegist(() => {
                wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
                    // alert(3)
                    wx.updateAppMessageShareData({
                        title: '优惠专区', // 分享标题
                        desc: "又有一批优惠券上架啦，快来领取吧！",
                        link: location.origin + "/mobile/#/tiketGet?YY_USER_ID=" + _this.$route.query.YY_USER_ID, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//                            imgUrl: location.origin + '/assets/img/card_bg.gif', // 分享图标
                        success: function () {
                            // alert(4)
//                                Toast({
//                                    message: "分享成功",
//                                    position: 'bottom',
//                                    duration: 5000
//                                });
                        }
                    })
                });
                // });
            },
            getAppid: function (callback) {
                api.getFormUrl(this, "/yy/front/getWxAppid", null, (res) => {
                    Indicator.close();
                    this.appid = res.appId;
                    this.appidAgent = res.componetAppId;
                    callback(res.componetAppId, res.appId)
                }, (err) => {
                    Indicator.close();
                    Toast({
                        message: err.rspDesc,
                        position: 'bottom',
                        duration: 5000
                    });
                });
            },
            loadBindInfo: function (callback) {
                var _this = this;
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=is>" + this.$route.query.openId;
                Indicator.open('加载中...');

                api.corsGet(url, (res) => {
                    Indicator.close();
                    if (res != "not find client") {
                        if (res == "") {
                            _this.hasBind = false;
                            _this.bindNo = "";
                        } else {
                            _this.hasBind = true;
                            _this.bindNo = res;
                            callback && callback();
                        }
                    }
                    _this.isRegist(null)
                }, (err) => {
                    Toast(err);
                    Indicator.close();
                })
            },
            jumpTo: function (path) {
                this.$router.push({
                    path: path,
                    query: {
                        YY_USER_ID: this.$route.query.YY_USER_ID,
                        openId: this.$route.query.openId || this.openId
                    }
                })
            },
            wxJsSdkAuth: function (params) {
//                alert(JSON.stringify(params))
                wx.config(Object.assign(params, {
//                    debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
                }));
                this.shareTicket();
            }
        },
        created: function () {
            var _this = this;
            utils.doIF(() => {
                // _this.form.name = this.$store.state.baseInfo.name;
                _this.loadBindInfo(() => {
                    _this.loadList(1);
                });
            }, () => {
                return !!this.$store.state.baseInfo && this.$route.query.openId;
            });
            // alert(1)
            _this.getAppid((appid, appid2) => {
                api.get(_this, "/wx/jsapiSignature?appId=" + appid2 + "&url=" + encodeURIComponent(location.href), null, (res) => {
                    // alert(2)
                    // alert(JSON.stringify(res.data.data))
                    _this.wxJsSdkAuth(res.data.data);
                }, () => {
                    // Toast("网络出错，请稍后再试");
                })
            });
        },
        mounted() {
            // this.loadList(1)
        }
    }
</script>

<style>
    .bg-head {
        position: relative;
        z-index: 1;
    }

    .mint-loadmore-text {
        font-size: 14px;
        color: #999;
    }

    .ticket-card {
        border-radius: 2px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        margin: 14px 14px 0 14px;
    }

    .ticket-bg {
        width: 100px;
        height: 102px;
        background: url("../assets/img/card_pre.gif") 0 0;
        background-size: cover;
    }

    .hint-text {
        color: #999;
    }

    .button {
        padding: 6px 0px;
        width: 60px;
        white-space: nowrap;
        box-sizing: border-box;
        text-align: center;
        color: white;
        background: linear-gradient(45deg, #3764f6, #7798fd);
        border-radius: 100px;
    }

    .button-2 {
        padding: 6px 0px;
        width: 60px;
        white-space: nowrap;
        box-sizing: border-box;
        text-align: center;
        color: white;
        background: linear-gradient(45deg, #ff660e, #ff960e);
        border-radius: 100px;
    }

    .button.cannot {
        background: #bbb;
    }

    .list-view {
        padding-bottom: 20px;
    }

    .no-data {
        letter-spacing: 2px;
    }

    .share-mask {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .7);
        z-index: 100;
    }
</style>